import { createReducer, on } from '@ngrx/store';

import {
  loadCalendarInspections,
  loadCalendarInspectionsFailed,
  loadCalendarInspectionsSuccess,
  updateCalendarInspection,
} from '@main-application/calendar/store/calendar.actions';
import { RestInspectionsModel } from '@main-application/inspections/models/rest-inspections-model.interface';

export const calendarFeatureKey = 'calendarState';

export interface State {
  visibleInspections: RestInspectionsModel[];
  visibleInspectionsLoading: boolean;
}

export const initialState: State = {
  visibleInspections: null,
  visibleInspectionsLoading: true,
};

export const reducer = createReducer(
  initialState,
  on(loadCalendarInspections, (state, action) => ({ ...state, visibleInspectionsLoading: true })),
  on(loadCalendarInspectionsSuccess, (state, action) => ({
    ...state,
    visibleInspections: action.inspections,
    visibleInspectionsLoading: false,
  })),
  on(loadCalendarInspectionsFailed, (state, action) => ({ ...state, visibleInspectionsLoading: false })),
  on(updateCalendarInspection, (state, action) => {
    // console.log('Updating inspection:', action.inspection);
    const updatedInspections = state.visibleInspections
      ? state.visibleInspections.map(inspection =>
          inspection.id === action.inspection.id ? { ...inspection, ...action.inspection } : inspection
        )
      : null;
    /* console.log(
      'Updated inspection:',
      updatedInspections.find(e => e.id === action.inspection.id)
    ); */
    return {
      ...state,
      visibleInspections: updatedInspections,
    };
  })
);
